import "core-js/modules/es.string.small.js";
import React from "react";
import { BadgeSizeEnum, BadgeTypeEnum, BadgeVariantEnum, RaiseBadge, RaiseColors, useTheme, useMediaQuery } from "componentLibrary";
import { isClientSide } from "utils/routeUtils";
import { getValidListingStateLabels } from "utils";
import { colorVariablesFormat } from "utils/stringUtils";
import { ListingStateEnum } from "utils/Enums";
import { jsx as _jsx } from "react/jsx-runtime";
var labelColor = {
  predicted: RaiseColors.amber500,
  on_market: RaiseColors.successBright,
  leased: RaiseColors.crimson1400,
  not_available: RaiseColors.black
};
var StatusBadge = function StatusBadge(_ref) {
  var listingState = _ref.listingState,
    className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? BadgeSizeEnum.small : _ref$size;
  var theme = useTheme();
  var isSmallScreen = useMediaQuery(theme.breakpoints.down("smMd"));

  // If size is medium and we're on a small screen, use small size instead
  var finalSize = size === BadgeSizeEnum.medium && isSmallScreen ? BadgeSizeEnum.small : size;
  var validListingState = getValidListingStateLabels(listingState);

  // Only show clients the status badge if the listingState is 'predicted' or 'leased'
  if (isClientSide() && listingState !== ListingStateEnum.PREDICTED.value && listingState !== ListingStateEnum.LEASED.value) {
    return null;
  }
  if (!validListingState) {
    return null;
  }
  var statusLabel = (validListingState === null || validListingState === void 0 ? void 0 : validListingState.label) || "";
  var color = (validListingState !== null && validListingState !== void 0 && validListingState.value ? labelColor[validListingState.value] : null) || RaiseColors.gray200; // fallback

  var badge = /*#__PURE__*/_jsx(RaiseBadge, {
    size: finalSize,
    variant: BadgeVariantEnum.filled,
    type: BadgeTypeEnum.primary,
    colorVariable: colorVariablesFormat(color, color),
    children: statusLabel
  });
  if (className) {
    return /*#__PURE__*/_jsx("div", {
      className: className,
      children: badge
    });
  }
  return badge;
};
export default StatusBadge;